export default "__VITE_ASSET__DE_19YcO__"